export interface LogUser {
  uuid: string;
  id: number;
  name: string;
  email: string;
}

export interface LogProps {
  id: number;
  uuid: string;
  user_id: number;
  type: string;
  route: string;
  method: string;
  ip_address: string;
  payload: any;
  response: any;
  message: string;
  status_code: number;
  tenant_id: number | null;
  created_at: string;
  updated_at: string;
  user: LogUser;
}

export const LogMethodColors = {
  GET: "bg-blue-500",
  POST: "bg-green-500",
  PUT: "bg-amber-500",
  DELETE: "bg-red-500",
  default: "bg-gray-500"
};

export const LogStatusColors = {
  200: "bg-green-500", // Success
  201: "bg-green-500", // Created
  204: "bg-green-500", // No Content
  400: "bg-amber-500", // Bad Request
  401: "bg-red-500",   // Unauthorized
  403: "bg-red-500",   // Forbidden
  404: "bg-red-500",   // Not Found
  422: "bg-amber-500", // Unprocessable Entity
  500: "bg-red-500",   // Server Error
  default: "bg-gray-500"
}; 